export default "__VITE_ASSET__DVdEW9q3__"